export const numeriqOfficeOptions = ['Zurich', 'Zug', 'Geneva'];
